import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import { URL } from '../helpers/FavouriteJourneysEndpoint';


const FavouriteJourneysService = {
    async getFavouriteJourneys (user) {
        try {
            const endpoint = URL.getFavouriteJourneys.replace('{id}', user.id);
            const response = await AuthenticatedAPIClient.get(endpoint);
            return response;
        } catch (e) {
            console.warn('error calling OCDR get favourite journeys service', e);
            return false;
        }
    },

    async saveFavouriteJourney (user, journey) {
        const endpoint = URL.saveFavouriteJourney.replace('{id}', user.id);
        const response = await AuthenticatedAPIClient.post(endpoint, journey);
        return response;
    },

    async deleteFavouriteJourney (user, journeyId) {
        try {
            const endpoint = URL.deleteFavouriteJourney.replace('{userId}', user.id).replace('{journeyId}', journeyId);
            const response = await AuthenticatedAPIClient.delete(endpoint, user, journeyId);
            return response;
        } catch (e) {
            console.warn('error calling OCDR delete favourite journey service', e);
            return false;
        }
    },

    async editFavouriteJourney (user, journey) {
        try {
            const endpoint = URL.editFavouriteJourney.replace('{userId}', user.id).replace('{journeyId}', journey.journeyId);
            const response = await AuthenticatedAPIClient.put(endpoint, journey);
            return response;
        } catch (e) {
            console.warn('error calling OCDR edit favourite journey service', e);
            return false;
        }
    },
};

export default FavouriteJourneysService;



// WEBPACK FOOTER //
// ./src/services/FavouriteJourneysService.js